var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowLongDownE(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.1573 22.1169C12.0153 22.2702 11.8159 22.3573 11.607 22.3573C11.398 22.3573 11.1986 22.2702 11.0566 22.1169L6.05663 16.7169C5.85409 16.4981 5.80033 16.1802 5.91968 15.907C6.03904 15.6339 6.30884 15.4573 6.60695 15.4573H10.857V9.57166H9.64246C8.53789 9.57166 7.64246 8.67623 7.64246 7.57167V3.57167C7.64246 2.4671 8.53789 1.57167 9.64246 1.57167L13.6425 1.57166C14.747 1.57166 15.6425 2.4671 15.6425 3.57166V7.57166C15.6425 8.67623 14.747 9.57165 13.6425 9.57165H12.357V15.4573H16.6069C16.9051 15.4573 17.1749 15.6339 17.2942 15.907C17.4136 16.1802 17.3598 16.4981 17.1573 16.7169L12.1573 22.1169Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLongDownE);
export default __webpack_public_path__ + "static/media/arrow-long-down-e.db1c8139a02a97b4ff8abc25364d9c0c.svg";
export { ForwardRef as ReactComponent };